import { withNamespaces } from 'react-i18next';
import {
    Card,
    CardBody,
    Progress,
} from 'reactstrap';

import { getPpwrRiskConfig } from 'src/modules/3rd-party-management/constants';

const MaterialCard = ({
    t,
    name,
    itemCount,
    riskLevel,
    compliancePercentage = 0,
}) => {
    const riskConfig = getPpwrRiskConfig(riskLevel);
    const percentage = Number(compliancePercentage) || 0;

    return (
        <Card
            className="h-100 mb-0"
            style={{ borderTop: `12px solid ${riskConfig.hex}` }}
        >
            <CardBody>
                <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                    <h6 className="mb-0">
                        {t(name)}
                    </h6>
                    <span
                        className="flex-shrink-0 fw-medium"
                        style={{ color: riskConfig.hex }}
                    >
                        {t(riskConfig.label)}
                    </span>
                </div>

                <p className="text-muted mb-4">
                    {`${Number(itemCount) || 0} ${t('Items')}`}
                </p>

                <div className="d-flex justify-content-start mb-1">
                    <small className='text-primary'>
                        {`${percentage}% ${t('compliant')}`}
                    </small>
                </div>

                <Progress
                    color={riskConfig.color}
                    value={percentage}
                />
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(MaterialCard);
